import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { getCurrentLanguage } from '../selectors';

const CmpMarathonBg = styled.div`
    display: block;
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
    z-index: -1;
    background: no-repeat center center #2f3e9d;
    background-size: cover;
    background-image: url(/static/img/bg/${props => (props.lang || 'en')}.jpg);
    transition: background-image 1s ease-in-out;
`;

const MarathonBg = connect(
    state => ({
        lang: getCurrentLanguage(state),
    }),
)(CmpMarathonBg);
export default MarathonBg;



// WEBPACK FOOTER //
// ./src/marathons/components/MarathonBg.jsx